module.exports = __webpack_public_path__ + "static/media/template-a.cf70f45d.svg";